import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, SimpleChange, ViewChild, ElementRef } from '@angular/core';
import { CatalogService } from '../catalogue/catalog-api/catalog.service';
import { ToasterService } from 'angular2-toaster';
import { ApiConstants } from '../shared';
import { GeneralConstants } from '../shared/general.constants';
import { get, difference } from 'lodash';
import moment = require('moment');
import { JwtHelper } from 'angular2-jwt';

declare var jQuery: any;

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'business-operations-catalog-manage',
    templateUrl: 'business-operations-catalog-manage.component.html',
    styleUrls: ['business-operations-catalog-manage.service.scss']
})
export class BusinessOperationsCatalogManageComponent implements OnInit {
    @ViewChild('modal', { read: ElementRef }) modal: ElementRef;
    @Input() selectedShow;
    originalData;
    dataLoaded = false;
    @Output() selectedShowChange = new EventEmitter();
    tabs = ['Overview', 'Meta Data', 'BoxOffice Data', 'Casts', 'Crews', 'Awards', 'Data Mapping', 'Images', 'Scheduling', 'Trailers', 'External Mappings', 'Verification'];
    selectedTab = this.tabs[0];
    editMode = false;
    catalogStates = ['demand_generation', 'data_collection', 'requested', 'harvested', 'metadata_ready'];
    isHelpdeskAdmin = false;
    showComponent = false;
    editLoading = false;
    importLoading = false;
    rejectMessage = '';
    rejectModalLoading = false;
    genres = null;
    languages = null;
    languagesValues = null;
    countries = null;
    countriesValues = null;
    titlesToAdd = [];
    occupationTags = [];

    constructor(
        private catalogService: CatalogService,
        private toasterService: ToasterService,
        private apiConstants: ApiConstants
    ) {}

    ngOnInit(): void {
        this.isHelpdeskAdmin = true;
        this.genres = Object.keys(this.apiConstants.GENRES) || [];
        this.languages = this.apiConstants.LANGUAGES.map(item => item.name);
        this.languagesValues = this.apiConstants.LANGUAGES.map(item => item.code);
        this.countries = this.apiConstants.COUNTRIES.map(item => item.displayName);
        this.countriesValues = this.apiConstants.COUNTRIES.map(item => item.iso);
    }

    ngOnChanges(changes: SimpleChanges) {
        this.titlesToAdd = [];
        this.selectedTab = this.tabs[0];
        if (changes.selectedShow) {
            const selectedShow: SimpleChange = changes.selectedShow;
            if (selectedShow.currentValue) {
                if (!selectedShow.previousValue || !selectedShow.previousValue.parrot_id || (selectedShow.previousValue.parrot_id !== selectedShow.currentValue.parrot_id)) {
                    this.dataLoaded = false;
                    this.editMode = false;
                    this.showDetails(selectedShow.currentValue);
                }
            }
        }
    }

    isLoading(): boolean {
        return this.editLoading || this.rejectModalLoading || this.importLoading;
    }

    showDetails(show) {
        this.showComponent = true;
        this.selectedShow = show;
        this.selectedShowChange.emit(this.selectedShow);
        this.dataLoaded = false;
        this.getMetaData(show);
    }

    async getMetaData(show) {
        const queryString = {
            'query': {
                'bool': {
                    'must': [
                        {
                            'term': {
                                '_id': {
                                    'value': show.id
                                }
                            }
                        }
                    ]
                }
            }
        };

        const chartNamesQueryString = {
            'query': {
                'bool': {
                    'must': [
                        {
                            'terms': {
                                'chart_name': show.chart_names
                            }
                        }
                    ]
                }
            }
        };

        const query = JSON.stringify(queryString);
        const chartNamesQuery = JSON.stringify(chartNamesQueryString);

        try {
            const businessApplicationsData = await this.catalogService.callEsProxyBusinessOperationsQueryMetadata(query, 'platform360-business-applications');
            const businessApplicationsMetaData = await this.catalogService.callEsProxyBusinessOperationsQueryMetadata(chartNamesQuery, 'platform360-analysis-metadata');

            this.dataLoaded = true;
            show.metadata = {};
            try {
                const val = businessApplicationsData.hits.hits[0]._source;
                const id = businessApplicationsData.hits.hits[0]._id;
                show.metadata.id = id;
                if (val) {
                    show.metadata.industry_segment = val.industry_segment;
                    show.metadata.business_question = val.business_question;
                }
            } catch (ex) {
                console.log(ex);
                show.metadata.industry_segment = 'Failed';
                show.metadata.business_question = 'Failed';
                show.metadata.chart_names = [];
            }

            try {
                const businessApplicationsMetaDataVal = businessApplicationsMetaData.hits.hits;
                show.metadata.chart_names = businessApplicationsMetaDataVal.map(hit => {
                    const source = hit._source;
                    return {
                        card_image_url: source.card_image_url,
                        helpcenter_url: source.helpcenter_url,
                        platform360_url: source.platform360_url,
                        entity_type: source.entity_type,
                        long_description: this.truncateDescription(source.long_description),
                        short_description: this.truncateDescription(source.short_description),
                        original_long_description: source.long_description,
                        original_short_description: source.short_description,
                        longDescriptionExpanded: false,
                        shortDescriptionExpanded: false,
                        analysis_name: source.analysis_name,
                        chart_name: source.chart_name,
                    };
                });
            } catch (ex) {
                console.log(ex);
                show.metadata.chart_names = [];
            }

            this.originalData = jQuery.extend(true, {}, this.selectedShow);
            this.selectedShowChange.emit(this.selectedShow);
        } catch (error) {
            this.dataLoaded = true;
            // this.errorHandler(error);
        }
    }

    openURL(url: string) {
        window.open(url, '_blank');
    }

    truncateDescription(description: string): string {
        if (description.length > 50) {
            return description.substring(0, 100) + '...';
        }
        return description;
    }

    toggleDescription(index: number, type: string) {
        const chart = this.selectedShow.metadata.chart_names[index];
        chart[type + 'Expanded'] = !chart[type + 'Expanded'];

        if (!chart[type + 'Expanded']) {
            chart[type] = chart['original_' + type];
        }
    }

    hideDetails() {
        this.showComponent = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/business-operations/business-operations-catalog-manage.component.ts